const defaultState = {
  width: '400px',
  height: '600px',
  isConnection: false,
  hideFlows: false,
  shouldDisable: () => false,
};

export default (state = defaultState, action) => {
  const newState = Object.assign({}, state);
  const { payload, status, type } = action;

  switch (type) {
    case 'SET_DIALOG_SIZE':
      newState.width = payload.width;
      newState.height = payload.height;
      return newState;
    case 'SET_WIDTH':
      newState.width = payload;
      return newState;
    case 'SET_HEIGHT':
      newState.height = payload;
      return newState;
    case 'SET_IS_CONNECTION':
      newState.isConnection = payload;
      return newState;
    case 'SET_HIDE_FLOWS':
      newState.hideFlows = payload
      return newState
    case 'SET_SHOULD_DISABLE':
      newState.shouldDisable = payload;
      return newState;
    case 'SET_OPERATION':
      newState.operation = payload;
      return newState;
  }

  return state;
};
